module.exports = __webpack_public_path__ + "img/Drop Down Menu - Gray.ec37e8bc.png";